<template>
  <Flex direction="column">
    <div :class="$style.header">
      <BaseHeading>{{ $t('service.nav.about.title') }}</BaseHeading>
      <BaseText
        v-if="!selected"
        iconBefore="edit"
      >
        {{ $t('global.actions.edit') }}
      </BaseText>
    </div>
    <div :class="$style.title">
      <BaseIcon
        name="briefcase"
        size="s"
        :color="!hasError ? 'default' : 'warning'"
      />
      <BaseText
        inline
        :italic="hasError"
      >
        {{ !hasError ? formData.name : $t('service.nav.about.name_required') }}
      </BaseText>
    </div>
    <div
      v-if="activeVariations.length === 1"
      :class="$style.info"
    >
      <BaseText iconBefore="credit-card">
        {{ formatCurrency(activeVariations[0].price) }}
      </BaseText>
      <BaseText iconBefore="clock">
        {{ activeVariations[0].duration }}
        {{ $t('global.minute_short') }}
      </BaseText>
    </div>
    <div v-else>
      <transition-group
        tag="div"
        name="swap"
      >
        <div
          v-for="variation in activeVariations"
          :key="`variation-overview-${variation.id}`"
          :class="$style.infoCard"
        >
          <BaseText
            :color="variation.variationName.length ? 'default' : 'warning'"
          >
            {{ variation.variationName.length
                ? variation.variationName
                : t('service.nav.about.variation_name_required') }}
          </BaseText>
          <div :class="$style.info">
            <BaseText iconBefore="credit-card">
              {{ formatCurrency(variation.price) }}
            </BaseText>
            <BaseText iconBefore="clock">
              {{ variation.duration }}
              {{ $t('global.minute_short') }}
            </BaseText>
          </div>
        </div>
      </transition-group>
    </div>
  </Flex>
</template>

<script
  lang="ts"
  setup
>
import { useI18n } from 'vue-i18n';
import { formatCurrency } from '@/helpers/currency';
import type { ServiceVariation, ServiceVariationsFormData } from '../types';

const { t } = useI18n();
const formData = inject<ServiceVariationsFormData>('serviceFormData')!;
const activeVariations = inject<ServiceVariation[]>('activeVariations')!;

const isServiceFormSubmitted = inject<Ref<boolean>>('isServiceFormSubmitted')!;
const hasError = computed(
  () => isServiceFormSubmitted.value && !formData.name.length,
);

defineProps<{
  selected: boolean;
}>();
</script>

<style
  lang="scss"
  module
>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: $spacing;
}

.title {
  display: flex;
  align-items: center;
  gap: $spacing * 0.25;
}

.info {
  display: flex;
  gap: $spacing * 2;
}

.infoCard {
  background-color: var(--color-bg);
  padding: $spacing;
  border: 1px solid var(--color-border);
  border-bottom: none;
  display: flex;
  flex-direction: column;
  gap: $spacing;

  &:first-child {
    border-radius: $radius $radius 0 0;
  }

  &:last-child {
    border-bottom: 1px solid var(--color-border);
    border-radius: 0 0 $radius $radius;
  }
}
</style>
